import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter } from "react-router-dom";
import './index.css';
import App from './home/App';
import reportWebVitals from './reportWebVitals';
import store from './stores/store';
import { Provider } from 'react-redux'
import AuthConfigure from './config/AuthConfigure';
// import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MemoryRouter>
        <AuthConfigure />
        <App />
      </MemoryRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
